const link = {
    primary: "#006DB6",
    hover: "#014F9F",
    text: "#207cb8",
    navbar: "#084a98",
};

export default link;
